
import QRCodeField from '../../../components/QRCodeField';
import { labelStyle, stepDescStyle } from '../styles';

/**
 * The record's code, and nothing else.
 *
 * QRCodeField generates one when the field is left empty: a collection with
 * no code cannot be found again, and asking somebody standing in a field to
 * invent one is how two specimens end up sharing it.
 */
export default function Step1({ t, user, form, setForm }) {
  return (
    <div>
      <p style={stepDescStyle}>{t('step1.desc')}</p>
      <label style={labelStyle}>
        {t('step1.label')}
        <QRCodeField
          value={form.qr_uid}
          onChange={v => setForm(f => ({ ...f, qr_uid: v }))}
          initials={user?.initials}
          autoGenerateIfEmpty={true}
        />
        <span style={{ fontSize: 11, color: 'var(--c-text-faint-fg)', marginTop: 2 }}>{t('step1.hint')}</span>
      </label>
    </div>
  );
}
